<template>
  <div>  
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/rum">Alla rum</router-link>
        <router-link tag="li" to="/rum/ny">Skapa ett nytt rum</router-link>
      </ul>
      <div class="clear"></div>
    </div>
    
    <div style="position:relative;height:250px;width:100%;">
      <div style="position:absolute;top:0px;z-index:1;width:100%;height:200px;" v-if="Object.keys(room).length">
        <div style="font-weight:bold;color:#FFF;margin-top:70px;padding-left:12px;font-size:40px;background:rgba(0, 0, 0, 0.10);">{{ room.name || 'Inget namn' }}</div>
      </div>
          
      <img :src="room.backURL" style="width:100%;height:250px;object-fit:cover;">
    </div>
    
    <hr class="space">
        
    <h3>Hantera</h3>
    <table>
      <tbody>
        <tr @click="edit"><td><img src="../assets/edit.png" style="margin-bottom:-5px;"> Redigera rummet</td></tr>    
        <!--<tr @click="favorite"><td style="color:#f1c40f;"><img src="../assets/star.png" style="margin-bottom:-5px;"> <span v-if="!room.favorite">Markera som favorit</span><span v-else>Ta bort favoritmarkering</span></td></tr>-->
        <tr @click="remove"><td style="color:#e74c3c;"><img src="../assets/delete.png" style="margin-bottom:-5px;"> Radera rummet</td></tr> 
      </tbody>
    </table>
    
    <hr class="space">
    
    <h3>Enheter i rummet</h3>
    <p class="descr">Du kan kontrollera och se status på alla dina enheter i rummet nedanför, statusen uppdateras automatiskt om den ändras medan du är här.</p>
    
    <div>      
      <table>
        <tbody>
          <tr v-for="node in getNodes">
            <td>{{ node.name }}</td>
            <td align="right"><capability-view :nodeId="node.id" :events="node.lastEvents" :capabilities="node.capabilities"></capability-view></td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div v-if="log.length">
      <hr class="space">
      
      <h3>Aktivitet i rummet</h3>
      <p class="descr">Detta är de senaste händelserna för just {{ room.name.toLowerCase() }}</p>
      
      <table>
        <tbody>
          <tr v-for="item in log" v-if="item.name in $root.capabilities">
            <td width="175">{{ item.time | moment("calendar") }}</td>
            <td width="350">{{ $root.data.nodes.find(node => node.id === item.sourceNode).name }}</td>
            <td>{{ $root.capabilities[item.name].name }}</td>
            <td align="right">
              <div v-if="$root.capabilities[item.name].type == 'number'">
               {{ item.value }}{{ $root.capabilities[item.name].unit }}
              </div>
              <div v-else-if="$root.capabilities[item.name].type == 'boolean'">
                {{ $root.capabilities[item.name].values[item.value].name }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import capabilityView from './views/capability'
  import { eventbus } from '../eventbus'

  export default {
    name: 'HelloWorld',
    components: {
      capabilityView
    },
    data () {
      return {
        log: []
      }
    },
    methods: {
      edit () {
        this.$router.push({
          name: 'rum_edit',
          params: {
            id: this.room.id
          }
        })
      },
      
      favorite () {
        
      },
      
      remove () {
        if (confirm('Är du säker på att du vill radera rummet?')) {

          this.getNodes.forEach(node => {
            HTTP.post('nodes/' + node.id, {
              roomId: 0
            })
          })
          
          HTTP.delete('rooms/' + this.room.id)
          
          const index = this.$root.data.rooms.findIndex(room => room.id === this.room.id)
          this.$root.data.rooms.splice(index, 1)

          
          this.$router.push({
            name: 'rum'
          })
        }
      }
    },
    created () {
      //HTTP.get('rooms/' + this.$route.params.id)
      //.then(res => res.data)
      //.then(json => this.room = json)
      
      const nodes = this.$root.data.nodes.filter(node => node.roomId === this.room.id).map(node => node.id)
      if (nodes.length) {
        let whereArray = []
        let whereString = ''
        
        nodes.forEach(node => whereArray.push('sourceNode=' + node))
        
        whereString = '&where=' + whereArray.join(' or ')
        
        HTTP.get('eventlog?limit=0,10' + whereString)
        .then(res => res.data)
        .then(json => this.log = json)                    
      }
            
      // Lyssnar på händelser på socketen och kolla så att enheten tillhör
      // rummet, isåfall lägger vi till den i loggen
      eventbus.$on('nodeEvent', (json) => {
        const node = this.$root.data.nodes.find(node => node.id === json.sourceNode)
        if (node.roomId === this.room.id) {
          let newArray = this.log.slice()
          newArray.unshift(json)
          this.log = newArray
        }
      })
    },
    computed: {
      getNodes () {
        return this.$root.data.nodes.filter(node => node.roomId == this.room.id)
      },
      
      room () {
        return this.$root.data.rooms.find(room => room.id === this.$route.params.id)
      }
    },
    
    destroyed () {
      eventbus.$off()
    }
  }
</script>

<style scoped>
  .room {
    transition:all 0.3s ease;
    cursor:pointer;
  }
  
  .room:hover {
      -webkit-transform: scale(0.99);
        -ms-transform: scale(0.99);
        transform: scale(0.99);
  }
</style>


// WEBPACK FOOTER //
// src/components/rum_detaljer.vue